import { PropsWithChildren, ReactNode } from 'react';
import { TableCommonStyles } from '../common-styles';
import { ManualFilterSectionHeader } from './manual-filter-section-header';

type ManualFilterSectionProps = PropsWithChildren<{
  sectionHeaderLabel: ReactNode;
  onClearClick?: (e: React.MouseEvent<HTMLElement>) => void;
  disableClear?: boolean;
  clearLabel?: string;
}>;

export const ManualFilterSection = ({
  sectionHeaderLabel,
  onClearClick,
  disableClear = false,
  clearLabel,
  children,
}: ManualFilterSectionProps) => {
  const filterSectionStyles = TableCommonStyles.tableFilterStyles({
    type: 'filterSection',
    extra: true,
  });

  return (
    <section css={filterSectionStyles}>
      <ManualFilterSectionHeader
        label={sectionHeaderLabel}
        disabled={disableClear}
        onClick={onClearClick}
        clearLabel={clearLabel}
      />
      {children}
    </section>
  );
};
